import { render, staticRenderFns } from "./ClicKanban.vue?vue&type=template&id=2eccdd58&scoped=true&"
import script from "./ClicKanban.vue?vue&type=script&lang=js&"
export * from "./ClicKanban.vue?vue&type=script&lang=js&"
import style0 from "./ClicKanban.vue?vue&type=style&index=0&id=2eccdd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eccdd58",
  null
  
)

export default component.exports